<template>

    <div>
        <div class="mb-6 pl-12 mx-auto ">
            <h1 class="font-bold text-4xl my-2">Simcard List</h1>
            <div class="mt-0 mb-4 text-gray-600">
                Simcards belongs to your account.
            </div>
            <hr class="my-8 border-b-2 border-gray-200">
        </div>
        <div class="pl-12 flex flex-wrap w-full mx-auto my-4">
            <template v-if="!isManager">
                <div class="w-4/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Filter Type
                    </label>
                    <div class="relative">
                        <select v-model="filterType"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option :value="null"></option>
                            <option value="email">Customer Email</option>
                            <option value="simcard_no">Simcard No</option>
                            <option value="serial_no">Serial No</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                </div>
                <div class="w-6/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Filter
                    </label>
                    <input v-model="filterText"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="w-2/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Search
                    </label>
                    <div class="relative w-full">
                        <button class="bg-blue-500 hover:bg-blue-700 disabled:opacity-50 text-white font-bold w-full py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                type="button"
                                @click="querySimcards"
                                :disabled="!canSearch || isLoading">
                            Search
                        </button>
                    </div>
                </div>
            </template>
            <template v-if="isManager">
                <div class="w-2/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Act Status
                    </label>
                    <div class="relative">
                        <select v-model="statusId"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option :value="null">All</option>
                            <option value="0">Not Scheduled</option>
                            <option value="1">Scheduled</option>
                            <option value="2">Activated</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                </div>
                <div class="w-4/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2"
                        :class="{
                            'opacity-50': statusId == 0
                        }">
                        Search Activation Date (UTC+8)
                    </label>
                    <v-date-picker
                        mode="range"
                        :min-date="form.minDate"
                        :max-date="form.maxDate"
                        v-model="range"
                        v-show="statusId != 0">
                        <!--Custom Input Slot-->
                        <input
                            id="date"
                            slot-scope="{ inputProps, inputEvents, isDragging }"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            :class="[`appearance-none rounded-l w-full py-2 px-3 ${ isDragging ? 'text-gray-400' : 'text-gray-700' }`]"
                            v-bind="inputProps"
                            v-on="inputEvents">
                    </v-date-picker>
                    <input class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight opacity-50"
                        disabled
                        v-show="statusId == 0">
                </div>
                <div class="w-2/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Carrier
                    </label>
                    <div class="relative">
                        <select v-model="carrierId"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option :value="null">All</option>
                            <option v-for="carrier in carriers"
                                    :key="carrier.id"
                                    :value="carrier.id">
                                {{ carrier.name }}
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                </div>
                <div class="w-2/12 px-1">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Search
                    </label>
                <div class="relative w-full">
                    <button class="bg-blue-500 hover:bg-blue-700 disabled:opacity-50 text-white font-bold w-full py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            type="button"
                            @click="querySimcards"
                            :disabled="!canSearch || isLoading">
                        Search
                    </button>
                    </div>
                </div>
                <div class="w-2/12 px-1" v-if="isManager">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Export
                    </label>
                    <div class="relative w-full">
                        <button class="bg-green-500 hover:bg-green-700 disabled:opacity-50 text-white font-bold w-full py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                type="button"
                                title="export as Excel"
                                :disabled="!canSearch || isLoading">
                            Export
                        </button>
                    </div>
                </div>
            </template>
        </div>
        <div class="pl-12 w-full mx-auto" v-show="hasQuried">
            <hr class="pl-12 my-8 border-b-2 border-gray-200">
        </div>
        <div class="pl-12 w-full mx-auto" v-show="hasQuried && simcards.length === 0">
            <div class="flex justify-center py-2">
                <div class="w-6/12">
                    <img src="../assets/images/not-found.svg">
                    <h6 class="text-4xl font-bold text-blue-500 text-center">Not Found</h6>
                </div>
            </div>
        </div>
        <div class="pl-12 flex flex-wrap w-full mx-auto my-4" v-show="isManager && simcards.length > 0">
            <div class="w-2/12 px-1">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Tag Simcards
                </label>
                <button type="button"
                    class="w-full px-1 py-1 bg-blue-500 rounded text-white"
                    title="tag simcards"
                    :class="{
                        'opacity-50': !anySimcardsHasChecked,
                    }"
                    :disabled="!anySimcardsHasChecked"
                    @click="openModal">
                    Select Tag
                </button>
            </div>
            <div :class="{
                'w-6/12': retailersTags.length === 0,
                'w-4/12': retailersTags.length > 0,
                }">
            </div>
            <div class="w-2/12 px-1" v-show="retailersTags.length > 0">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Custom Tag
                </label>
                <div class="relative">
                    <select class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            v-model="form.tagId">
                        <option :value="null"></option>
                        <option v-for="tag in retailersTags"
                                :value="tag.id"
                                :key="tag.id">
                            {{ tag.name }}
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>
            <div class="w-4/12 px-1">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Search <span class="text-gray-500 text-xs font-normal">( Simcard No, Serial No, Phone No )</span>
                </label>
                <div class="relative">
                    <input type="text"
                           class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           v-model="form.search"/>
                </div>
            </div>
        </div>
        <div class="pl-12 w-full mx-auto" v-show="simcards.length > 0">
            <table class="table-auto w-full">
                <thead>
                    <tr>
                        <th class="px-4 py-2" v-if="isManager">
                            <input type="checkbox"
                                   class="form-checkbox"
                                   title="Select All"
                                   @click="toggleAll"
                                   :checked="allSimcardHasBeenSelectedInThisPage"
                            >
                        </th>
                        <th class="px-4 py-2"  v-if="isManager">Tag</th>
                        <th class="px-4 py-2">Simcard No</th>
                        <th class="px-4 py-2">Serial No</th>
                        <th class="px-4 py-2">Phone No</th>
                        <th class="px-4 py-2">Carrier</th>
                        <th class="px-4 py-2">Plan</th>
                        <th class="px-4 py-2">Scheduled Act Date (UTC+8)</th>
                        <th class="px-4 py-2">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="simcard in simcardsInThisPage"
                        :key="simcard.simcard_no">
                        <td class="border px-4 py-2" v-if="isManager">
                            <label class="flex items-center">
                                <input type="checkbox" class="form-checkbox"
                                       :checked="simcard.checked"
                                       @click="toggleSimcard({
                                           simcard_no: simcard.simcard_no,
                                           checked: !simcard.checked
                                       })">
                            </label>
                        </td>
                        <td class="border px-4 py-2" v-if="isManager">
                            <div v-if="simcard.tag_id"
                                class="px-1 py-1 rounded bg-gray-300 text-xs text-center text-gray-600 truncate">
                                {{ retailersTagsMag[simcard.tag_id] }}
                            </div>
                        </td>
                        <td class="border px-4 py-2">
                            {{ simcard.simcard_no }}
                        </td>
                        <td class="border px-4 py-2">
                            {{ simcard.serial_no }}
                        </td>
                        <td class="border px-4 py-2">
                            {{ simcard.phone_no }}
                        </td>
                        <td class="border px-4 py-2">
                            <div v-if="simcard.carrier_id"
                                class="px-1 py-1 rounded bg-gray-200 tracking-tighter text-xs text-center text-gray-600 truncate">
                                {{ carrierNameMap[simcard.carrier_id] }}
                            </div>
                        </td>
                        <td class="border px-4 py-2">
                            <div v-if="simcard.plan_id"
                                class="px-1 py-1 rounded bg-gray-200 tracking-tight text-xs text-center text-gray-600 truncate">
                                {{ planNameMap[simcard.plan_id] }}
                            </div>
                        </td>
                        <td class="border px-4 py-2">
                            <span class="text-xs">{{ simcard.activated_date | toYMD }}</span>
                        </td>
                        <td class="border px-4 py-2">
                            <div v-if="simcard.status == 0"
                                class="px-1 py-1 rounded bg-gray-300 text-xs text-center text-gray-600 truncate">
                                Not Scheduled
                            </div>
                            <div v-if="simcard.status == 1"
                                class="px-1 py-1 rounded bg-gray-600 text-xs text-center text-white truncate">
                                Scheduled
                            </div>
                            <div v-if="simcard.status == 2"
                                class="px-1 py-1 rounded bg-green-500 text-xs text-center text-white truncate">
                                Activated
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pl-12 flex flex-wrap w-full mx-auto mt-10" v-show="simcards.length > 0">
            <div class="w-2/12 px-1">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Entries per page
                </label>
                <div class="relative">
                    <select class="block appearance-none w-full bg-white-200 border border-gray-200 text-gray-700 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        v-model="table.perPage">
                        <option v-for="num in [10, 25, 50, 100, 250, 500]"
                                :key="num"
                                :value="num">
                            {{ num }}
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>
            <div class="w-8/12">
            </div>
            <div class="w-2/12 px-1">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Pagination
                </label>
                <div class="flex flexwrap">
                    <button class="border border-gray-200 text-gray-700 py-1 px-2 leading-tight"
                        type="button"
                        :class="{
                            'opacity-50': table.page <= 1
                        }"
                        :disabled="table.page <= 1 "
                        @click="table.page -= 1">
                        <i class="material-icons">
                            keyboard_arrow_left
                        </i>
                    </button>
                    <div class="relative">
                        <select class="block appearance-none bg-white-200 border border-gray-200 text-gray-700 py-2 pl-5 pr-10 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            v-model="table.page"
                            :disable="totalPage == 1">
                            <option v-for="num in totalPage"
                                    :key="num"
                                    :value="num">
                                {{ num }}
                            </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    <button class="border border-gray-200 text-gray-700 py-1 px-2 leading-tight"
                        type="button"
                        :class="{
                            'opacity-50': table.page >= totalPage
                        }"
                        :disabled="table.page >= totalPage "
                        @click="table.page += 1">
                        <i class="material-icons">
                            keyboard_arrow_right
                        </i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal Below -->
        <Modal title="Assign a Tag"
               :modalShown="modalShown"
               :isValid="dataIsValid"
               v-on:confirm="assignTag"
               v-on:cancel="closeModal">
            <template v-slot:body>
                <form>
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                            Assign a tag to the {{ numOfSimcardsHasChecked }} simcards.
                        </label>
                        <div class="relative">
                            <select class="block appearance-none w-full bg-white-200 border border-gray-200 text-gray-700 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                v-model="tagId">
                                <option v-for="tag in retailersTags"
                                        :value="tag.id"
                                        :key="tag.id">
                                    {{ tag.name }}
                                </option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
        </Modal>

    </div>

</template>


<script>
import XLSX from 'xlsx';
import Vue from 'vue';
import VCalendar from 'v-calendar';
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex'
import Modal from './Modal.vue';

Vue.use(VCalendar);


export default {

    components: {
        Modal,
    },

    data() {
        return {

            form: {
                minDate: (function(){
                    let date = new Date;
                    date.setFullYear(date.getFullYear()-5);
                    return date;
                })(),
                maxDate: (function(){
                    let date = new Date;
                    date.setFullYear(date.getFullYear()+2);
                    return date;
                })(),
                search: null,
                tagId: null,
            },

            table: {
                perPage:50,
                page: 1,
            }

        }
    },

    computed: {

        ...mapState(
            'auth',
            [
                'isManager',
            ]
        ),

        ...mapState(
            'simcardList',
            [
                'isLoading',
                'carriers',
                'retailersTags',
                'simcards',
                'selectedCarrierId',
                'selectedStatusId',
                'selectedFilterType',
                'filterContent',
                'hasQuried',
                'modalShown',
                'tagIdAssignTo',
                'selectedRange',
            ]
        ),

        ...mapGetters(
            'simcardList',
            [
                'carrierNameMap',
                'planNameMap',
                'retailersTagsMag',
                'simcardsHasChecked',
                'numOfSimcardsHasChecked',
                'anySimcardsHasChecked',
            ]
        ),

        canSearch () {

            return this.isManager ? true : this.selectedFilterType && this.filterContent && this.filterContent.trim().length > 5;

        },

        tagId: {
            get() {
                return this.tagIdAssignTo;
            },
            set(val) {
                this.changeTagId({tagId:val});
            }
        },

        carrierId: {
            get() {
                return this.selectedCarrierId;
            },
            set(val) {
                this.setSelectedCarrierId(val);
            }
        },

        statusId: {
            get() {
                return this.selectedStatusId;
            },
            set(val) {
                this.setSelectedStatusId(val);
            }
        },

        filterType: {
            get() {
                return this.selectedFilterType;
            },
            set(val) {
                this.setSelectedFilterType(val);
            },
        },

        filterText: {
            get() {
                return this.filterContent;
            },
            set(val) {
                this.setFilterContent(val ? val.trim() : null);
            },
        },

        range: {
            get() {
                return this.selectedRange;
            },
            set(val) {
                this.setSelectedRange(val);
            }
        },

        dataIsValid() {
            return this.anySimcardsHasChecked
                && this.tagIdAssignTo;
        },

        simcardsFiltered() {

            const tagId   = this.form.tagId ? +this.form.tagId : null;
            const keyword = this.form.search ?
                            this.form.search.trim().toUpperCase() : null;

            return  this.simcards.filter( simcard => {
                       return (
                        !tagId
                        || simcard.tag_id === tagId
                       )
                       &&
                       (
                           !keyword || (
                                ~simcard.simcard_no.indexOf(keyword) ||
                                ( simcard.serial_no && ~simcard.serial_no.indexOf(keyword) ) ||
                                ( simcard.phone_no && ~simcard.phone_no.indexOf(keyword) )
                            )
                       );
                   });
        },

        firstIdx() {
            return ( this.table.page - 1 ) * this.table.perPage;
        },

        lastIdx() {
            return this.table.page * this.table.perPage - 1;
        },

        totalPage() {
            return this.simcardsFiltered.length === 0 ?
                   1 :
                   Math.ceil(this.simcardsFiltered.length / this.table.perPage );
        },

        simcardsSorted() {
            return this.simcardsFiltered;
        },

        simcardsInThisPage() {
            const firstIdx = this.firstIdx;
            const lastIdx  = this.lastIdx;

            return this.simcardsSorted.filter( (simcard, idx) => {
                return idx >= firstIdx && idx <= lastIdx;
            });
        },

        allSimcardHasBeenSelectedInThisPage() {
            return this.simcardsInThisPage.length > 0
                && this.simcardsInThisPage.every(simcard => simcard.checked);
        },

    },

    watch: {
        totalPage(newVal) {
            if(newVal < this.table.page) {

                this.table.page = 1;
            }
        }
    },

    methods: {

        ...mapMutations(
            'simcardList',
            [
                'setSimcards',
                'setSelectedCarrierId',
                'setSelectedStatusId',
                'setSelectedRange',
                'setSelectedFilterType',
                'setFilterContent',
            ],
        ),

        ...mapActions(
            'simcardList',
            [
                'fetchCarriers',
                'fetchRetailersTags',
                'fetchPlans',
                'fetchSimcards',
                'fetchReport',
                'changeTagId',
                'toggleSimcard',
                'assignTagToSimcards',
                'quit',
                'openModal',
                'closeModal',
            ]
        ),

        querySimcards() {
            this.fetchSimcards({
                status: this.statusId,
                carrier_id: this.carrierId,
                from: this.range ? this.range.start : null,
                to: this.range ? this.range.end : null,
                type: this.filterType ? this.filterType : null,
                text: this.filterText ? this.filterText : null,
            });
        },

        toggleAll() {

            const simcardNosInThisPage = this.simcardsInThisPage.map(simcard=>simcard.simcard_no);

            const simcardShouldBeChecked = this.allSimcardHasBeenSelectedInThisPage ?
                                           () => false :
                                           simcard => ~simcardNosInThisPage.indexOf(simcard.simcard_no);

            const simcards = this.simcards.map(function(simcard){
                simcard.checked = simcardShouldBeChecked(simcard);
                return simcard;
            })

            this.setSimcards(simcards);

        },

        assignTag() {
            this.assignTagToSimcards({
                tagId: this.tagIdAssignTo,
                simcards: this.simcardsHasChecked,
            });
        },

        exportAsExcel() {

            this.fetchReport({
                status: this.statusId,
                carrier_id: this.carrierId,
                from: this.range ? this.range.start : null,
                to: this.range ? this.range.end : null,
            }).then(sheetDatas => {

                const [firstSheetData, ...otherSheetDatas] = sheetDatas;

                const filename = "aerobile_retailer_report.xlsx";

                const wb = XLSX.utils.book_new();
                const firstSheet = XLSX.utils.aoa_to_sheet(firstSheetData.sheet_content);
                XLSX.utils.book_append_sheet(wb, firstSheet, firstSheetData.sheet_name);

                otherSheetDatas.forEach( sheetData => {
                    const sheet = XLSX.utils.json_to_sheet(
                        sheetData.sheet_content,
                        {
                            headers: [
                                'Simcard No',
                                'Serial No',
                                'Phone No',
                                'Plan',
                                'Scheduled Act Date (UTC+8)'
                            ],
                        });
                     XLSX.utils.book_append_sheet(wb, sheet, sheetData.sheet_name);
                });

                XLSX.writeFile(wb, filename);
            });

        },

    },

    created() {
        this.fetchCarriers();
        this.fetchPlans();

        if (this.isManager) {
            this.fetchRetailersTags();
        }
    },

    destroyed() {
        this.quit();
    }
}

</script>

<style scoped>
</style>
